import React from "react";
import { PlanContainer } from "../../styled/info";
import { FaCheck } from "react-icons/fa6";
import PlanItem from "./planItem";
import { plans } from "../common/plans";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const PlanList = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);

  const selectPlan = (name) => {
    alert("준비중입니다.");
    return;
    if (name === "free") return;
    if (!user) {
      toast.error("로그인 후 이용 가능합니다.", { toastId: "no-access" });
      navigate("/login");
    } else {
      toast.success("구독할 회사를 선택해주세요.", { toastId: "no-access" });
      navigate("/mypage/companies");
    }
  };

  return (
    <PlanContainer>
      <ul>
        {Object.entries(plans).map(([key, value]) => (
          <PlanItem value={value} clickEvent={selectPlan} />
        ))}
      </ul>
      <button
        onClick={
          () => alert("준비중입니다.")
          //  toast.error("구독 요금을 선택해주세요.")
        }>
        매달 정기 결제
      </button>
    </PlanContainer>
  );
};

export default PlanList;
